import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Menu, X } from 'lucide-react';
import { restaurantInfo } from '../mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/menu', label: 'Menu' },
    { path: '/about', label: 'About' },
    { path: '/events', label: 'Events' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/testimonials', label: 'Testimonials' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="text-2xl font-bold" style={{ fontFamily: "'Playfair Display', serif", color: '#E84118' }}>
              The Grill
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-medium transition-colors duration-200 ${
                  location.pathname === link.path
                    ? 'text-[#E84118]'
                    : 'text-[#333333] hover:text-[#E84118]'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Phone & Mobile Menu Button */}
          <div className="flex items-center space-x-4">
            <a
              href={`tel:${restaurantInfo.phone}`}
              className="hidden md:flex items-center space-x-2 px-4 py-2 rounded-lg bg-[#F39C12] text-white hover:bg-[#e67e22] transition-colors duration-200"
            >
              <Phone className="w-4 h-4" />
              <span className="font-semibold">Call Now</span>
            </a>

            {/* Mobile Menu Toggle */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden p-2 text-[#333333]"
            >
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`font-medium transition-colors duration-200 ${
                    location.pathname === link.path
                      ? 'text-[#E84118]'
                      : 'text-[#333333] hover:text-[#E84118]'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href={`tel:${restaurantInfo.phone}`}
                className="flex items-center space-x-2 px-4 py-2 rounded-lg bg-[#F39C12] text-white w-fit"
              >
                <Phone className="w-4 h-4" />
                <span className="font-semibold">Call Now</span>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
